import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { SearchProvider, useSearch } from './context/SearchContext';
import { ThemeProvider } from './context/ThemeContext';
import SearchSection from './components/SearchSection';
import ResultsSection from './components/ResultsSection';
import SettingsSection from './components/SettingsSection';
import AppNavbar from './components/Navbar';
import BookSection from './components/BookSection';

// Navigation order for keyboard navigation
const NAVIGATION_ORDER = ['search', 'results', 'book', 'history', 'settings'];

function AppContent() {
  const { 
    hasSearched, 
    activeView, 
    setActiveView, 
    searchTerm,
    setSearchTerm,
    focusSearchInput,
    results
  } = useSearch();
  
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Don't handle keyboard navigation when user is typing in search
      if (e.target.tagName === 'INPUT') {
        // Handle ESC in search input
        if (e.key === 'Escape' && activeView === 'search') {
          e.preventDefault();
          setSearchTerm('');
          focusSearchInput();
        }
        return;
      }

      switch (e.key) {
        case 'ArrowLeft': {
          e.preventDefault();
          const currentIndex = NAVIGATION_ORDER.indexOf(activeView);
          if (currentIndex > 0) {
            setActiveView(NAVIGATION_ORDER[currentIndex - 1]);
          }
          break;
        }
        case 'ArrowRight': {
          e.preventDefault();
          const currentIndex = NAVIGATION_ORDER.indexOf(activeView);
          if (currentIndex < NAVIGATION_ORDER.length - 1) {
            setActiveView(NAVIGATION_ORDER[currentIndex + 1]);
          }
          break;
        }
        case 'Escape': {
          e.preventDefault();
          if (activeView === 'book') {
            if (results && results.length > 0) {
              setActiveView('results');
            } else {
              // No results, so go back to search
              setActiveView('search');
            }
          } else if (activeView === 'results') {
            setActiveView('search');
          }
          break;
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeView, setActiveView, setSearchTerm, focusSearchInput, results]);

  const renderContent = () => {
    switch (activeView) {
      case 'search':
        return <SearchSection />;
      case 'results':
        return <ResultsSection />;
      case 'book':
        return <BookSection />;
      case 'history':
        return <div>Coming soon...</div>;
      case 'settings':
        return <SettingsSection />;
      default:
        return <SearchSection />;
    }
  };

  return (
    <>
      <AppNavbar />
      <Container>
        {renderContent()}
      </Container>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <SearchProvider>
        <AppContent />
      </SearchProvider>
    </ThemeProvider>
  );
}

export default App;
